export const DEALS_TAB_KEYS = {
  INVESTOR: 'investor',
  PROVIDER: 'provider',
  COMPANY_PROFILES: 'company-profiles',
  DEMAND: 'demand',
  PIPELINE: 'pipeline',
} as const;
